import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import toastStore from '@/stores/toast-store.js'
import axios from 'axios'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'

import AddDeliveryRequestReceiverData from '../add-delivery-request-receiver-data/cmp.vue'

export default {
  name: 'AddDeliveryRequestStart',
  mixins: [CurrentUserResolver],
  extends: BaseModal,
  data: function () {
    return {
      collectomates: [],
      blocker: false,
    }
  },
  mounted() {
    this.fetchCollectomates()
  },
  computed: {
    cpsWithByDelivererScenario() {
      return this.collectomates.length
        ? this.collectomates.filter(cp => cp.deliveryScenarios.indexOf('by_deliverer') != -1)
        : []
    },
  },
  methods: {
    fetchCollectomates() {
      this.blocker = true
      axios({
        method: 'get',
        url: 'collection_points',
      })
        .then(response => {
          this.collectomates = response.data
          this.blocker = false
          console.log('AddDeliveryRequestStart fetchCollectomates response', response)
        })
        .catch(error => {
          const errorMessage = error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
          this.blocker = false
        })
    },

    selectCollectomate(collectionPoint) {
      this.$store.commit('modal/open', {
        cmp: AddDeliveryRequestReceiverData,
        animation: 'slide-left-modal',
        data: {
          collectionPoint: collectionPoint,
          sender: this.currentUser,
        },
      })
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
